import React from "react";
import { Row, Col, Typography, Button } from 'antd';

// ICONS
import { IoAlbums, IoAperture, IoApps, IoArrowBackCircle, IoBag, IoBook, IoBusiness, IoCalendar, IoCloseCircle, IoDocument, IoMenu, IoPeople, IoReader, IoSettings } from "react-icons/io5";
import { Link } from "react-router-dom";

class PlataformaMenu extends React.Component {

    state = { selected: null, title: '' }

    render = () => {

        const { onMenu } = this.props

        if (this.props.type === 'pc') {
            return (
                <Row gutter={[8,8]} justify={'center'}>
                    <Col xs={24}>
                        <Link to="cadastros"><Button type="link" shape="round" block className="menu-button"><IoAlbums className="menu-button-icon" />Cadastros</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="configuracoes"><Button type="link" shape="round" block className="menu-button"><IoSettings className="menu-button-icon" />Configurações</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="dadossistema"><Button type="link" shape="round" block className="menu-button"><IoDocument className="menu-button-icon" />Dados do Sistema</Button></Link>
                    </Col>
                    {/* <Col md={24} style={{display: 'flex', alignItems: 'center'}}>
                        <Typography className="menu-text">Cadastros</Typography>
                    </Col>
                    <Col md={24}>
                        <Link to="agencias"><Button type="link" shape="round" block className="menu-button"><IoBusiness className="menu-button-icon" />Agências</Button></Link>
                    </Col>
                    <Col md={24}>
                        <Button disabled type="link" shape="round" block className="menu-button"><IoBag className="menu-button-icon" />Fornecedores</Button>
                    </Col>
                    <Col md={24}>
                        <Link to="usuarios"><Button type="link" shape="round" block className="menu-button"><IoPeople className="menu-button-icon" />Usuários</Button></Link>
                    </Col>
                    <Col md={24} style={{display: 'flex', alignItems: 'center'}}>
                        <Typography className="menu-text">Configurações</Typography>
                    </Col>
                    <Col md={24}>
                        <Link to="permissoes"><Button type="link" shape="round" block className="menu-button"><IoAperture className="menu-button-icon" />Permissões</Button></Link>
                    </Col>
                    <Col md={24}>
                        <Link to="tipousuario"><Button type="link" shape="round" block className="menu-button"><IoApps className="menu-button-icon" />Tipos de Usuário</Button></Link>
                    </Col>
                    <Col md={24}>
                        <Button disabled type="link" shape="round" block className="menu-button"><IoBook className="menu-button-icon" />Logs</Button>
                    </Col>
                    <Col md={24} style={{display: 'flex', alignItems: 'center'}}>
                        <Typography className="menu-text">Dados do Sistema</Typography>
                    </Col>
                    <Col md={24}>
                        <Link to="generos"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPeople className="menu-button-icon" />Gêneros</Button></Link>
                    </Col>
                    <Col md={24}>
                        <Link to="estadocivil"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPeople className="menu-button-icon" />Estado Civíl</Button></Link>
                    </Col>
                    <Col md={24}>
                        <Link to="agendastatus"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoReader className="menu-button-icon" />Agenda Situação</Button></Link>
                    </Col>
                    <Col md={24}>
                        <Link to="agendatipo"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoMenu className="menu-button-icon" />Agenda Prioridade</Button></Link>
                    </Col> */}
                    
                </Row>
            )
        }

        if (this.props.type === 'app') {
            return (
                <Row gutter={[16,16]} justify={'center'}>
                    {/* PRINCIPAL */}
                    { this.state.selected === null ? <>
                        <Col xs={24} style={{display: 'flex', alignItems: 'center'}}>
                            <Button key={'back'} onClick={onMenu} type="link" shape="circle" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><IoCloseCircle size={28} color="var(--fourth)" /></Button><Typography className="menu-text">Menu</Typography>
                        </Col>
                        <Col xs={12}>
                            <Button onClick={() => this.setState({selected: 'cadastros', title: 'Cadastros'})} type="link" shape="round" block className="menu-button"><IoAlbums className="menu-button-icon" />Cadastros</Button>
                        </Col>
                        <Col xs={12}>
                            <Button onClick={() => this.setState({selected: 'configuracoes', title: 'Configurações'})} type="link" shape="round" block className="menu-button"><IoSettings className="menu-button-icon" />Configurações</Button>
                        </Col>
                    </> : <>
                        <Col xs={24} style={{display: 'flex', alignItems: 'center'}}>
                            <Button key={'back'} onClick={() => this.setState({selected: null})} type="link" shape="circle" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><IoArrowBackCircle size={28} color="var(--fourth)" /></Button><Typography className="menu-text">{this.state.title}</Typography>
                        </Col>
                    </> }
                    {/* CADASTROS */}
                    { this.state.selected === 'cadastros' ? <>
                        <Col xs={12}>
                            <Link to="agencias"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoBusiness className="menu-button-icon" />Agências</Button></Link>
                        </Col>
                        <Col xs={12}>
                            <Button disabled type="link" shape="round" block className="menu-button"><IoBag className="menu-button-icon" />Fornecedores</Button>
                        </Col>
                        <Col xs={12}>
                            <Link to="usuarios"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPeople className="menu-button-icon" />Usuários</Button></Link>
                        </Col>
                    </> : null }
                    {/* CONFIGURAÇÕES */}
                    { this.state.selected === 'configuracoes' ? <>
                        <Col xs={12}>
                            <Link to="permissoes"><Button type="link" shape="round" block className="menu-button"><IoAperture className="menu-button-icon" />Permissões</Button></Link>
                        </Col>
                        <Col xs={12}>
                            <Link to="tipousuario"><Button  onClick={onMenu} type="link" shape="round" block className="menu-button"><IoApps className="menu-button-icon" />Tipos de Usuário</Button></Link>
                        </Col>
                        <Col xs={12}>
                            <Button disabled type="link" shape="round" block className="menu-button"><IoBook className="menu-button-icon" />Logs</Button>
                        </Col>
                        <Col xs={12}>
                            <Link to="generos"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPeople className="menu-button-icon" />Gêneros</Button></Link>
                        </Col>
                        <Col xs={12}>
                            <Link to="estadocivil"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPeople className="menu-button-icon" />Estado Civíl</Button></Link>
                        </Col>
                        <Col xs={12}>
                            <Button onClick={() => this.setState({selected: 'agenda', title: 'Agenda'})} type="link" shape="round" block className="menu-button"><IoCalendar className="menu-button-icon" />Agenda</Button>
                        </Col>
                    </> : null }
                    {/* AGENDA */}
                    { this.state.selected === 'agenda' ? <>
                        <Col xs={12}>
                            <Link to="agendastatus"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoReader className="menu-button-icon" />Situação</Button></Link>
                        </Col>
                        <Col xs={12}>
                            <Link to="agendatipo"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoMenu className="menu-button-icon" />Prioridade</Button></Link>
                        </Col>
                    </> : null }
                </Row>
            )
        }

    }

}

export default PlataformaMenu;